import qc from './qc'
import sp from './sp'
import innovate from './innovate'
import common from './common'
import demonstration from './demonstration'
import architect from './architect'
import hqp from './hqp'
import msg from './msg'
import gdp from './gdp'
import tap from './tap'
import ead from './ead'


export default {
  qc,
  sp,
  innovate,
  common,
  demonstration,
  architect,
  msg,
  hqp,
  gdp,
  tap,
  ead
}



// WEBPACK FOOTER //
// ./src/api/psm/index.js